import { useLocation } from "react-router-dom";

// Which dashboard root the current page is mounted under.
//
// The project pages are shared between the Project Manager (/pm) and the company
// Admin (/admin-co) — an admin is not a lesser PM, they can do everything a PM
// can, so giving them a second, thinner copy of the same screens was how the two
// drifted apart. Sharing them means their internal links can't be hardcoded:
// `navigate("/pm/projects/…")` from the admin surface would bounce the admin into
// a tree their sidebar doesn't cover.
//
// Add a root here, not at each call site.
const ROOTS = ["/admin-co", "/pm"];

export function useSurfaceBase() {
  const { pathname } = useLocation();
  // Longest-prefix match: "/admin-co" must win before any shorter root added later.
  return ROOTS.find((r) => pathname === r || pathname.startsWith(`${r}/`)) || "/pm";
}

export default useSurfaceBase;
